const APIS = {
  USER: '/usermanagementservice/api/user/',
  SUBSCRIPTION: 'client-subscription/get-client-info/',
  WEBSITE: '/get-website/',
  WELCOME_PAGE: '/get-welcome-image/',
  CONFIGURATION: '/projectsettingsservice/api/configuration/',
};

export default APIS;
